import React from "react";

import { DeleteConfirmation } from "@/design-system/components/DeleteConfirmation/DeleteConfirmation";

const TransformationDeleteModal: React.FC<{
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  header: string;
  body?: string;
}> = ({ isOpen, onClose, onConfirm, header, body }) => (
  <DeleteConfirmation
    open={isOpen}
    title={header}
    description={body ?? "This action is irreversible."}
    onCancel={onClose}
    onConfirm={onConfirm}
  />
);

export { TransformationDeleteModal };
